import React, { ReactNode, ReactElement } from 'react'
import { Text, Flex, ThemeUIStyleObject } from 'theme-ui'

interface FeaturesInfoBoxProps {
  title: string
  leftColumnContent?: ReactNode
  rightColumnContent?: ReactNode
  mainContent?: ReactNode
  hasShadedBackground: boolean
  sxLeftColumnContent?: ThemeUIStyleObject
  sxRightColumnContent?: ThemeUIStyleObject
}

export default function FeaturesInfoBox({
  title,
  leftColumnContent,
  rightColumnContent,
  mainContent,
  hasShadedBackground,
  sxLeftColumnContent,
  sxRightColumnContent,
}: FeaturesInfoBoxProps): ReactElement {
  return (
    <Flex
      sx={{
        borderRadius: '30px',
        flexDirection: 'column',
        width: ['100%', '100%', '108rem'],
        p: ['1.6rem', '4.8rem'],
        backgroundColor: hasShadedBackground ? 'darkItemBG50' : 'transparent',
        boxShadow: hasShadedBackground
          ? ({ colors }): string => `0 1.6rem 2.4rem 0 ${colors?.darkItemBoxShadow}`
          : 'none',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
      }}
    >
      <Text
        sx={{
          fontSize: ['2.8rem', '4rem', '4.8rem'],
          fontWeight: 'bold',
          pb: ['2.4rem', '4.8rem'],
        }}
      >
        {title}
      </Text>
      {mainContent ? (
        <Flex
          sx={{
            width: '100%',
            fontSize: '2.1rem',
            fontWeight: 'normal',
            color: 'white50',
            textAlign: 'center',
            justifyContent: 'center',
          }}
        >
          <Flex>{mainContent}</Flex>
        </Flex>
      ) : (
        <Flex
          sx={{
            fontSize: '2.1rem',
            fontWeight: 'normal',
            color: 'white50',
            gap: ['1.6rem', '4.8rem'],
            textAlign: ['center', 'center', 'left'],
            flexDirection: ['column', 'column', 'row'],
            alignItems: ['center', 'center', 'flex-start'],
          }}
        >
          <Flex
            sx={{
              height: '100%',
              flex: 1,
              justifyContent: ['center', 'flex-start'],
              alignItems: 'center',
              ...sxLeftColumnContent,
            }}
          >
            {leftColumnContent}
          </Flex>
          <Flex
            sx={{
              height: '100%',
              flex: 1,
              justifyContent: ['center', 'flex-start'],
              alignItems: 'center',
              ...sxRightColumnContent,
            }}
          >
            {rightColumnContent}
          </Flex>
        </Flex>
      )}
    </Flex>
  )
}
